export default "__VITE_ASSET__B7L9GAV2__"